
import { UserBaseMailPermission } from "@/commons/interfaces";
import { useSidClient } from "@/plugins/auth";
import { useRouter } from "vue-router";
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "@/store";
import useDeterring from "@/commons/useDeterring";
import { MailPermissionItem } from "@/modules/mailPermission";

export default defineComponent({
    name: "MailPermissionConfirm",
    setup() {
        const sidClient = useSidClient();
        const router = useRouter();
        const store = useStore();
        const { isDeterringRef, asyncDeterringWrap } = useDeterring();

        const mailPermissionItem = MailPermissionItem.inject();
        const userMailPermission = mailPermissionItem.mailPermission as UserBaseMailPermission;
        const errorMsgRef = ref("");

        /**
         * 確認ボタン押下時処理
         * @async
         */
        const update = async () => {
            try {
                // 要求用にオブジェクトをコピー
                const reqObj = Object.assign({}, userMailPermission);
                // メール受信許可情報更新
                const payload = JSON.parse(JSON.stringify({
                    mailPermissionInfo: reqObj.mailPermissionInfo,
                    manageInfo: reqObj.manageInfo,
                }));
                await sidClient.requestApi({
                    method: "PUT",
                    path: "/user/mail_permission",
                    body: payload
                });

            } catch (e) {
                if (e.message === "Request failed with status code 404") {
                    // メール受信許可情報再取得して保持
                    await store.dispatch("fetchUserMailPermission");
                    mailPermissionItem.setMailPermission(store.state.userMailPermission);

                    // 楽観的排他（バージョン違い）によるエラー発生（404：Not Found）
                    // メール受信設定更新画面へ遷移
                    await router.push({ name: "MailPermission", query: { errorMsg: "メール受信設定の更新に失敗しました。再度お試し下さい。" } });
                    return;
                }
                errorMsgRef.value = "メール受信設定の更新に失敗しました。後ほど再度お試し下さい。";
                return;
            }

            // メール受信設定更新完了へ遷移
            router.push({ name: "MailPermissionComplete" });
        };

        /**
         * キャンセルボタン押下時処理
         */
        const cancel = () => {
            // メール受信設定更新画面へ遷移
            router.push({ name: "MailPermission" });
        };

        /**
         * ページを離れる場合の確認アラート起動
         * @event
         */
        const confirmSave = (event: any) => {
            event.returnValue = "編集中のものは保存されませんが、よろしいですか？";
        };

        onMounted(() => {
            window.addEventListener("beforeunload", confirmSave);
        });

        onUnmounted(() => {
            window.removeEventListener("beforeunload", confirmSave);
        });

        return {
            isDeterringRef,
            asyncDeterringWrap,
            userMailPermission,
            errorMsgRef,
            update,
            cancel
        };
    },
});
